import React, { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';

import { input } from '$gbusiness/helpers';
import { FormSection } from '$gcomponents/reusables';
import { Button, Text } from '$gcomponents/primitives';
import { AppForm } from '$styles/general';
import { factoryActions } from '$fbusiness/redux/factory';
import { AppModel } from '$business/redux/';

import { STORE_LEVEL_FORM } from './storeLevelForm';
import StoreLevelModel from '$fbusiness/models/storeLevel';
import { configs } from '$configs';
import { IonContent } from '@ionic/react';
import Footer from '$gcomponents/widgets/footer';

interface StoreLevelDetailsProps {
  storeLevel: StoreLevelModel;
  onClose: Function;
}

const StoreLevelDetails: React.FC<StoreLevelDetailsProps> = ({ storeLevel, onClose }) => {
  const dispatch = useDispatch();
  const roles = useSelector((state: AppModel) => state.factory.roles);
  const isFinished = useSelector((state: AppModel) => state.factory.isFinished);
  const formRef = useRef<any>();

  useEffect(() => {
    if (!isFinished) return;
    dispatch(factoryActions.resetFinished());
    onClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFinished, dispatch, onClose]);

  if (!storeLevel) return null;
  const { id, level, ...initialValues } = storeLevel;

  const onSubmit = (values) => {
    const newValues = {
      ...values,
    };
    dispatch(
      factoryActions.saveObj(id || 0, newValues, configs.api.storeLevel, factoryActions.fetchStoreLevels),
    );
  };

  const storeLevelForm = STORE_LEVEL_FORM(roles);

  const validateForm = (values) => {
    return input.validateError(storeLevelForm, values);
  };

  return (
    <Formik
      innerRef={formRef}
      enableReinitialize={true}
      initialValues={{
        ...initialValues,
        level: level || '0',
      }}
      validate={validateForm}
      onSubmit={(values) => {
        onSubmit(values);
      }}>
      {(formik) => (
        <>
          <IonContent>
            <div className="content">
              <AppForm>
                <FormSection FORM={storeLevelForm} formik={formik} />
              </AppForm>
            </div>
          </IonContent>
          <Footer justifyContent="center">
            <Button className="half" onClick={formik.handleSubmit} disabled={!formik.isValid}>
              <Text k="BUTTON.SAVE" />
            </Button>
          </Footer>
        </>
      )}
    </Formik>
  );
};

export default StoreLevelDetails;
